import { StyledSelect } from "@/components/StyledSelect";
import { Toggle } from "@/components/Toggle";
import { useTrans } from "@/translations";

import { Dispatch, FC, SetStateAction, useMemo } from "react";
import Skeleton from "react-loading-skeleton";

export type PricingType = {
  currency: string;
  price: string;
};

type Props = {
  pricing?: PricingType;
  isLoading: boolean;
  isSaving: boolean;
  setPricing: Dispatch<SetStateAction<PricingType | undefined>>;
  enableTenantPayments: boolean;
  setEnableTenantPayments: Dispatch<SetStateAction<boolean>>;
};

export const currencies = [
  { label: "GBP", value: "gbp", symbol: "£" },
  { label: "NOK", value: "nok", symbol: "kr" },
  { label: "EUR", value: "eur", symbol: "€" },
];

export const Payments: FC<Props> = ({
  pricing = { currency: "", price: "" },
  isLoading,
  setPricing,
  isSaving,
  enableTenantPayments,
  setEnableTenantPayments,
}) => {
  const { t } = useTrans();

  const disabled = isLoading || isSaving;

  const content = useMemo(() => {
    if (!enableTenantPayments) {
      return null;
    }

    return (
      <div>
        <div className="mt-4">
          <label className="select-none">{t("configLabels:pricing")}</label>
          <div className="mt-2 flex items-center">
            <input
              type="text"
              value={pricing.price}
              onChange={(e) =>
                setPricing({ ...pricing, price: e.target.value })
              }
              className="font-dm-sans placeholder:text-grey6 disabled:border-grey3 disabled:text-grey6 mr-2 box-border h-10 w-full rounded-none border border-black p-3 text-sm focus:outline-2 focus:-outline-offset-2 focus:outline-solid"
              disabled={disabled}
              data-1p-ignore
            />
            <StyledSelect
              name={"configLabels:currency"}
              options={currencies}
              value={currencies.find((c) => c.value === pricing.currency)}
              onChange={(v) => setPricing({ ...pricing, currency: v.value })}
              isDisabled={disabled}
              className="min-w-20"
            />
          </div>
        </div>
      </div>
    );
  }, [enableTenantPayments, t, disabled, setPricing, pricing]);

  return (
    <div className="mt-4">
      {isLoading ? (
        <Skeleton count={1} height={26} />
      ) : (
        <>
          <Toggle
            label={t("configLabels:paymentsEnabled")}
            checked={enableTenantPayments}
            onChange={setEnableTenantPayments}
          />
          {content}
        </>
      )}
    </div>
  );
};
